import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL;

export default function ManagementSwapRequests() {
    const [pending, setPending] = useState([]);
    const [archive, setArchive] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchAll = () => {
        setIsLoading(true);
        Promise.all([
            axios.get(`${API_URL}/Custom/GetManagementSwapRequests`),
            axios.get(`${API_URL}/Custom/GetArchivedSwapRequest`)
        ])
            .then(([{ data: p }, { data: a }]) => {
                setPending(p);
                setArchive(a);
            })
            .catch(err => {
                console.error(err);
                Swal.fire({ title: 'Hata', text: 'Talepler yüklenirken hata oluştu.', icon: 'error' });
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        fetchAll();
    }, []);

    const handleDecision = (requestId, approve) => {
        const action = approve ? 'Onayla' : 'Reddet';
        Swal.fire({
            title: `Yapacağınız işlem: ${action}. Emin misiniz?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: action,
            cancelButtonText: 'Vazgeç'
        }).then(result => {
            if (!result.isConfirmed) return;
            axios.post(`${API_URL}/Custom/ManageSwapRequest`, { requestId, approve })
                .then(() => {
                    Swal.fire({ title: 'Başarılı', text: `Talep ${approve ? 'onaylandı' : 'reddedildi'}.`, icon: 'success' });
                    fetchAll();
                })
                .catch(err => {
                    console.error(err);
                    Swal.fire({ title: 'Hata', text: 'İşlem sırasında bir hata oluştu.', icon: 'error' });
                });
        });
    };

    if (isLoading) return <div>Yükleniyor...</div>;

    return (
        <div className="container my-4">
            {/* Pending */}
            <h4>Yönetim Onayı Bekleyen Değişim Talepleri</h4>
            {pending.length === 0 ? (
                <p>Yönetim onayı bekleyen talep yok.</p>
            ) : (
                <table className="table table-striped mt-3">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Başvuran</th>
                            <th>Verilmek İstenen Görev</th>
                            <th>Talep Edilen Kişi</th>
                            <th>Talep Edilen Görev</th>
                            <th>Değişim İstenen Sınıflar</th>
                            <th>Gerekçe</th>
                            <th>Kanıt</th>
                            <th>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pending.map(r => (
                            <tr key={r.id}>
                                <td>{r.id}</td>
                                <td>{r.applicantName}</td>
                                <td>
                                    {r.slotDate} <br />
                                    {r.startTime.substring(0, 5)} – {r.endTime.substring(0, 5)}
                                </td>
                                <td>{r.targetUserName}</td>
                                <td>
                                    {r.requestedSlots.map(rs => (
                                        <div key={rs.id}>
                                            {rs.slotDate}<br />
                                            {rs.startTime.substring(0, 5)} – {rs.endTime.substring(0, 5)}
                                        </div>
                                    ))}
                                </td>
                                <td style={{ whiteSpace: 'pre-wrap' }}>{r.classroomDetails}</td>
                                <td style={{ whiteSpace: 'pre-wrap' }}>{r.reason || '-'}</td>
                                <td>
                                    {r.evidencePath ? (
                                        <a
                                            href={`${API_URL.slice(0, -3)}${r.evidencePath}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-sm btn-outline-primary"
                                        >
                                            İndir
                                        </a>
                                    ) : (
                                        <span>Kanıt eklenmedi</span>
                                    )}
                                </td>
                                <td>
                                    <button className="btn btn-sm btn-success me-2" onClick={() => handleDecision(r.id, true)}>
                                        Onayla
                                    </button>
                                    <button className="btn btn-sm btn-danger" onClick={() => handleDecision(r.id, false)}>
                                        Reddet
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {/* Archive */}
            <hr />
            <h4>Arşiv (Onaylandı / Reddedildi / İptal Edildi)</h4>
            {archive.length === 0 ? (
                <p>Arşivde talep yok.</p>
            ) : (
                <table className="table table-striped mt-3">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Başvuran</th>
                                <th>Verilmek İstenen Görev</th>
                            <th>Talep Edilen Kişi</th>
                                <th>Talep Edilen Görev</th>
                                <th>Değişim İstenen Sınıflar</th>
                            <th>Gerekçe</th>
                            <th>Kanıt</th>
                                <th>Durum</th>
                        </tr>
                    </thead>
                    <tbody>
                        {archive.map(r => (
                            <tr key={r.id}>
                                <td>{r.id}</td>
                                <td>{r.applicant}</td>
                                <td>
                                    {r.origDate}<br />
                                    {r.origStart.substring(0, 5)} – {r.origEnd.substring(0, 5)}
                                </td>
                                <td>{r.target}</td>
                                <td>
                                    {r.requested.map(rs => (
                                        <div key={rs.id}>
                                            {rs.slotDate}<br />
                                            {rs.startTime.substring(0, 5)} – {rs.endTime.substring(0, 5)}
                                        </div>
                                    ))}
                                </td>
                                <td style={{ whiteSpace: 'pre-wrap' }}>{r.classroomDetails}</td>
                                <td style={{ whiteSpace: 'pre-wrap' }}>{r.reason || '-'}</td>
                                <td>
                                    {r.evidencePath ? (
                                        <a
                                            href={`${API_URL.slice(0, -3)}${r.evidencePath}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-sm btn-outline-primary"
                                        >
                                            İndir
                                        </a>
                                    ) : (
                                        <span>Kanıt eklenmedi</span>
                                    )}
                                </td>
                                <td>{r.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
